<template>
  <p>Mars Inc. 2019</p>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
p {
  text-align: center;
  color: #a3a3a3;
  font-size: 0.75rem;
  user-select: none;
}
</style>
